<template>
  <div class="main">
    <el-row class="btn-back">
      <el-button
        @click="$router.go(-1)"
        type="primary"
        icon="el-icon-back"
        circle
      ></el-button>
    </el-row>
    <h2>{{ courseName }}</h2>
    <h2>Modulo {{ moduleName }} , Lição {{ lessonName }}</h2>
    <el-row :gutter="20">
      <el-col :span="6">
        <draggable
          :list="list"
          :disabled="!enabled"
          class="list-group"
          v-bind="dragOptions"
          @start="dragging = true"
          @end="dragging = false"
        >
          <transition-group type="transition" name="flip-list">
            <div
              class="list-group-item"
              v-for="(element, idx) in list"
              :key="element.id"
            >
              <el-card class="box-card" shadow="hover">
                <div slot="header" class="clearfix">
                  <span> Lição </span>
                  <el-button
                    style="float: right"
                    icon="el-icon-menu"
                  ></el-button>
                  <el-button
                    style="float: right"
                    icon="el-icon-delete"
                    @click="removeAt(idx)"
                  ></el-button>
                </div>
                <div>
                  <el-col :span="18" class="card-item list-group-item">
                    <div class="card-item-content">
                      <label> Titulo da Lição: </label>
                      <el-input v-model="element.title"></el-input>
                    </div>
                    <div class="card-item-content">
                      <label> Lição: </label>
                      <el-input
                        v-if="element.lessonTypes == 'texto'"
                        type="textarea"
                        v-model="element.name"
                      ></el-input>
                      <el-radio-group
                        :v-model="radio"
                        v-if="element.lessonTypes == 'quiz'"
                      >
                        <el-radio v-for="(subElement, subIndex) in quizList" :key="subElement.label" :v-model="subIndex" >{{subElement.name}} <br/></el-radio>
                        <button @click="pushQuisList" >Adcionar mais</button>
                      </el-radio-group>
                      <el-upload
                        v-if="element.lessonTypes == 'video'"
                        class="upload-demo"
                        :action="linkUpload"
                        :headers="myHeaders"
                        :data="dataObjects"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        :before-upload="submitUpload"
                        multiple
                        :limit="3"
                        :on-exceed="handleExceed"
                        :file-list="fileList"
                      >
                        <el-button size="small" type="primary"
                          >Adcionar Video</el-button
                        >
                        <div slot="tip" class="el-upload__tip">
                          mp4/jpg/png arquivos
                        </div>
                      </el-upload>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <label> Tipo Recurso: </label>
                    <el-select
                      v-model="element.lessonTypes"
                      placeholder="Tipos"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </div>
              </el-card>
            </div>
          </transition-group>
        </draggable>
      </el-col>
    </el-row>
    <el-button icon="el-icon-plus" @click="add()"></el-button>
    <el-button @click="viewCourse"> Visulizar curso </el-button>

    <!-- <rawDisplayer class="col-3" :value="list" title="List" /> -->
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import axios from 'axios';
let id = 1;
export default {
  components: {
    draggable,
  },
  data() {
    return {
      radio : `10`,
      myHeaders: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
      courseName: '',
      userId: '',
      linkUpload: `${process.env.VUE_APP_API}/upload/`,
      dataObjects: {
        pathName: '',
      },
      lessonName: '',
      moduleName: '',
      enabled: true,
      list: [
        { title: 'Exemple', name: 'Exemple', id, lessonTypes: '' },
        // { title: 'teste', name: '12121', id: id++ },
      ],
      quizList:[
        { label: 1, name: 'Exemple'},
      ],
      dragging: false,
      tipoLicao: 'textarea',
      options: [
        {
          value: 'video',
          label: 'Video',
        },
        {
          value: 'texto',
          label: 'Texto',
        },
        {
          value: 'quiz',
          label: 'Questiónario',
        },
      ],
      fileList: [],
    };
  },
  async created() {
    const data = await this.getData();
    console.log(data);
    this.courseName = data.courses[0].name;
    this.userId = data.courses[0].userId;
    this.token = localStorage.getItem('token');
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
        dataModule: {},
      };
    },
  },
  methods: {
    viewCourse() {
      let newstring = this.courseName.replaceAll(' ', '-');
      const courseId = this.$route.params.courseId;
      this.$router.push(
        '/course/' + this.userId + '/' + courseId + '/' + newstring
      );
    },
    pushQuisList() {
      console.log(this.quizList)
      this.quizList.push({ label: this.quizList.length + 1, name: `Teste ${this.quizList.length + 1}` });
    },
    submitUpload(file) {
      console.log(file.name);
      console.log(this.moduleName);
      const isMP4 = file.type === 'video/mp4';
      if(!isMP4) {
        this.$message.error('Somente arquivos mp4');
      }
      else{
        this.dataObjects.pathName = this.moduleName + '-' + this.lessonName;
        let newstring = this.dataObjects.pathName.replaceAll(' ', '-');
        this.dataObjects.pathName = newstring;
        console.log(this.dataObjects.pathName);
        let content =
          'videos/' +
          this.userId +
          '/' +
          this.dataObjects.pathName +
          '-' +
          file.name;

        const save = async () => {
          await axios.patch(
            process.env.VUE_APP_API + '/lessons/' + this.$route.params.id,
            {
              type: 'video',
              content,
              title: this.list[0].title
            }
          );
        };
        save();
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `The limit is 3, you selected ${
          files.length
        } files this time, add up to ${files.length + fileList.length} totally`
      );
    },
    beforeRemove(file) {
      return this.$confirm(`Deseja remover ${file.name} ?`);
    },
    add: function () {
      this.list.push({ id: id++, title: '', name: '' });
    },
    removeAt(idx) {
      this.list.splice(idx, 1);
    },
    checkMove(e) {
      window.console.log('Posicao futura: ' + e.draggedContext.futureIndex);
    },
    async getData() {
      const courseId = this.$route.params.courseId;
      // const moduleId = this.$route.params.moduleId;
      const response = await axios.get(
        process.env.VUE_APP_API + '/courses/' + courseId
      );
      response.data.modules.filter((module) => {
        if (module.id == this.$route.params.moduleId) {
          this.moduleName = module.name;
          module.lessons.filter((lesson) => {
            if (lesson.id == this.$route.params.id) {
              this.lessonName = lesson.name;
            }
          });
        }
      });
      // this.dataModule = response.data.modules.filter((mdl) => {
      //   if (mdl.id == moduleId);
      // });
      // console.log(this.dataModule);
      return response.data;
    },
  },
};
</script>
<style lang="scss"  scoped>
.buttons {
  margin-top: 35px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.main {
  display: flex;
  .btn-back {
    width: 100%;
  }
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.list-group {
  width: 70vw;
  flex-direction: column;
  justify-content: space-between;
}
.list-group-item {
  margin-top: 20px;
}
.el-card {
  padding: 20px;
}
.card-item-content {
  padding: 10px;
}
.list-complete-enter,
.list-complete-leave-active {
  opacity: 0;
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>
